@if (sponsorTop && !is_video && !data.iframe_data.hide_sponsors) {
    <div class="sponsor-img-container">
        <!-- <ng-container *ngIf="videAdSponsorBanner?.id; else elseBlock">
    <app-image [image_url]="videAdSponsorBanner.image_url" height="auto" [width]="'auto'" [aspect_ratio]="'9/1'" (click)="postEvent(sponsorTop, true)"></app-image>
  </ng-container>
  <ng-template #elseBlock>
    <app-image [image_url]="sponsorTop.image_url" height="auto" [width]="'auto'" [aspect_ratio]="'9/1'" (click)="postEvent(sponsorTop)"></app-image>
  </ng-template> -->
    </div>
}

@if (validURL()) {
    <div class="webview-container">
        @if (!is_video) {
            <button class="close-button" mat-icon-button (click)="closeSheet()"><mat-icon>close</mat-icon></button>
        }
        @if (!is_video) {
            <iframe [src]="getURL() | iframeSrc" frameborder="0" allowfullscreen="true" webkitallowfullscreen="true" mozallowfullscreen="true"></iframe>
        }
    </div>
}

@if (shouldShowDowloadSection()) {
    <div class="download-app-notice">
        <h3>{{ appStringAPI.getAppString('web.app.required') }}</h3>
    </div>
}

@if (sponsorBottom && !is_video && !data.iframe_data.hide_sponsors) {
    <div class="sponsor-img-container">
        <!-- <ng-container *ngIf="videAdSponsorBanner?.id; else elseBlock">
    <app-image [image_url]="videAdSponsorBanner.image_url" height="auto" [width]="'auto'" [aspect_ratio]="'9/1'" (click)="postEvent(sponsorBottom, true)"></app-image>
  </ng-container>
  <ng-template #elseBlock>
    <app-image [image_url]="sponsorBottom.image_url" height="auto" [width]="'auto'" [aspect_ratio]="'9/1'" (click)="postEvent(sponsorBottom)"></app-image>
  </ng-template> -->
    </div>
}
